const PAISE_PER_RUPEE = 100;
const MONTHS_PER_YEAR = 12;

function roundMoney(value: number) {
  return Math.round(value);
}

function roundCurrencyValue(value: number) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function toRupees(valueInPaise: number) {
  return valueInPaise / PAISE_PER_RUPEE;
}

export function formatInrNumber(value: number, options?: Intl.NumberFormatOptions) {
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0,
    ...options,
  }).format(value);
}

export const CURRENCY_CODE = 'INR';
export const GST_RATE = 0.18;
export const GST_RATE_PERCENT = GST_RATE * 100;
export const WALLET_MIN_RECHARGE_AMOUNT_INR = 100;

// Exclusive of GST. Adjust this value to update the derived annual and
// monthly subscription pricing everywhere.
export const BASE_PRICE_PAISA = 1_271_102;

export function calculateGstAmountPaise(basePricePaise: number, gstRate = GST_RATE) {
  return roundMoney(basePricePaise * gstRate);
}

export function calculateFinalPricePaise(basePricePaise: number, gstRate = GST_RATE) {
  return basePricePaise + calculateGstAmountPaise(basePricePaise, gstRate);
}

export function calculateMonthlyPricePaise(yearlyPricePaise: number) {
  return roundMoney(yearlyPricePaise / MONTHS_PER_YEAR);
}

export function calculateInclusivePriceBreakdown(finalAmount: number, gstRate = GST_RATE) {
  const roundedFinalAmount = roundCurrencyValue(finalAmount);
  const baseAmount = roundCurrencyValue(roundedFinalAmount / (1 + gstRate));
  const gstAmount = roundCurrencyValue(roundedFinalAmount - baseAmount);

  return {
    baseAmount,
    gstAmount,
    finalAmount: roundedFinalAmount,
    gstRate,
    gstRatePercent: gstRate * 100,
  };
}

export const GST_AMOUNT_PAISA = calculateGstAmountPaise(BASE_PRICE_PAISA);
export const FINAL_PRICE_PAISA = calculateFinalPricePaise(BASE_PRICE_PAISA);
export const MONTHLY_PRICE_PAISA = calculateMonthlyPricePaise(FINAL_PRICE_PAISA);

export const BASE_PRICE = toRupees(BASE_PRICE_PAISA);
export const GST_AMOUNT = toRupees(GST_AMOUNT_PAISA);
export const FINAL_PRICE = toRupees(FINAL_PRICE_PAISA);
export const MONTHLY_PRICE = toRupees(MONTHLY_PRICE_PAISA);

export const SUBSCRIPTION_PRICING = {
  basePricePaise: BASE_PRICE_PAISA,
  gstAmountPaise: GST_AMOUNT_PAISA,
  finalPricePaise: FINAL_PRICE_PAISA,
  monthlyPricePaise: MONTHLY_PRICE_PAISA,
  basePriceInr: BASE_PRICE,
  gstAmountInr: GST_AMOUNT,
  finalPriceInr: FINAL_PRICE,
  monthlyPriceInr: MONTHLY_PRICE,
  currency: CURRENCY_CODE,
} as const;

export { MONTHS_PER_YEAR, PAISE_PER_RUPEE };
